export default __webpack_public_path__ + "static/media/timer1.91b69d57.png";